<div class="question-group-selector">
    <ng-select [items]="questionGroups" [multiple]="true" [loading]="loading" [disabled]="disabled" bindLabel="title"
        bindValue="id" [ngModel]="selectedIds" (ngModelChange)="onSelectionChange($event)" [hideSelected]="true"
        placeholder="Seleccionar grupos de preguntas...">
        <ng-template ng-option-tmp let-item="item">
            <div>
                <strong>{{ item.title }}</strong>
                <small class="text-muted d-block" *ngIf="item.description">{{ item.description }}</small>
            </div>
        </ng-template>
    </ng-select>

    <!-- Selected Groups Configuration Table -->
    <div class="mt-3" *ngIf="selectedLinks.length > 0">
        <label class="form-label small fw-bold text-muted">Configuración de Grupos Seleccionados</label>
        <div class="table-responsive border rounded">
            <table class="table table-sm table-hover mb-0">
                <thead class="bg-light">
                    <tr>
                        <th style="width: 50%" class="ps-3">Grupo</th>
                        <th style="width: 40%">Fase</th>
                        <th style="width: 10%"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let link of selectedLinks; let i = index" class="cursor-pointer"
                        (click)="editGroup(link)">
                        <td class="align-middle ps-3">
                            <span class="text-dark fw-bold">
                                {{ getGroupTitle(link.questionGroupId) }}
                            </span>
                        </td>
                        <td (click)="$event.stopPropagation()">
                            <select class="form-select form-select-sm" [ngModel]="link.phase"
                                (ngModelChange)="onPhaseChange(i, $event)" [disabled]="disabled">
                                <option *ngFor="let opt of phaseOptions" [value]="opt.value">{{ opt.label }}</option>
                            </select>
                        </td>
                        <td class="text-end pe-3">
                            <button type="button" class="btn btn-sm btn-link text-danger p-0"
                                (click)="removeLink(i); $event.stopPropagation()" [disabled]="disabled"
                                title="Remover grupo">
                                <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="mt-2">
        <button type="button" class="btn btn-sm btn-outline-colonial" (click)="openCreateModal()" [disabled]="disabled">
            <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">add</span>
            Crear nuevo grupo
        </button>
    </div>
</div>